module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    class: _vm.table_class
  }, [_vm._t("columns_content", function() {
    return [_c('thead', [(_vm.editable || _vm.deletable || _vm.duplicatable) ? _c('tr', [_c('td', {
      staticClass: "column_0"
    }), _vm._v(" "), _vm._l((_vm.table.items), function(data, index) {
      return _c('td', {
        key: index,
        staticClass: "column_1"
      }, [_c('div', {
        staticClass: "flex"
      }, [(_vm.editable) ? _c('button', {
        staticClass: "ui icon button purple mini compact",
        on: {
          "click": function($event) {
            return _vm.$emit('edit_clicked', data)
          }
        }
      }, [_c('i', {
        staticClass: "icon edit"
      })]) : _vm._e(), _vm._v(" "), (_vm.deletable) ? _c('button', {
        staticClass: "ui icon button red mini compact",
        on: {
          "click": function($event) {
            return _vm.$emit('delete_clicked', data)
          }
        }
      }, [_c('i', {
        staticClass: "icon trash"
      })]) : _vm._e(), _vm._v(" "), (_vm.duplicatable) ? _c('button', {
        staticClass: "ui icon button orange mini compact",
        on: {
          "click": function($event) {
            return _vm.$emit('duplicate_clicked', data)
          }
        }
      }, [_c('i', {
        staticClass: "icon copy"
      })]) : _vm._e()])])
    })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.columns), function(col, index) {
      return _c('tr', {
        key: index
      }, [_c('td', {
        class: col.class
      }, [_vm._v(_vm._s(col.name))]), _vm._v(" "), _vm._l((_vm.table.items), function(data, index) {
        return _c('td', {
          key: index
        }, [_vm._t(col.id, function() {
          return [_vm._v(_vm._s(data[col.id]))]
        }, {
          "item": data,
          "data": data[col.id]
        })], 2)
      })], 2)
    }), 0)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55891a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datatable.vue
// module id = 499
// module chunks = 1